import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  membershipLevelContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    width: '100%',
    minWidth: '240px',
  },
  inactiveSilver: {
    display: 'flex',
    flexDirection: 'row',
    padding: '3px 7px',
    width: '25%',
    marginTop: '3px',
    backgroundColor: theme.evPalette.charcoal[500],
  },
  inactiveBronze: {
    display: 'flex',
    flexDirection: 'row',
    padding: '3px 7px',
    width: '25%',
    marginTop: '3px',
    borderRadius: '15px 0px 0px 15px',
    backgroundColor: theme.evPalette.charcoal[500],
  },
  inactivePlat: {
    display: 'flex',
    flexDirection: 'row',
    padding: '3px 7px',
    width: '25%',
    marginTop: '3px',
    borderRadius: '0px 15px 15px 0px',
    backgroundColor: theme.evPalette.charcoal[500],
  },
  activeTitle: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '15px 15px 15px 15px',
    padding: '6px 7px',
    width: '25%',
    position: 'absolute',
    '&.Bronze': {
      backgroundColor: theme.evPalette.mango[900],
      left: '0%',
    },
    '&.Silver': {
      backgroundColor: theme.evPalette.charcoal[800],
      left: '25%',
    },
    '&.Gold': {
      backgroundColor: theme.evPalette.mango[700],
      left: '50%',
    },
    '&.Platinum': {
      backgroundColor: theme.evPalette.ocean[900],
      left: '75%',
    },
    '&.Custom': {
      backgroundColor: theme.evPalette.ocean[700],
      left: '0%',
      position: 'relative',
    },
  },
  inactiveText: {
    color: theme.evPalette.charcoal[700],
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
    margin: 'auto',
    textTransform: 'uppercase',
  },
  activeText: {
    color: theme.evPalette.salt[100],
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
    margin: 'auto',
    textTransform: 'uppercase',
  },
}));
